import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../@types/RootState';
import {
  CHANGE_QUICK_FILTER_VALUE,
  TOGGLE_QUICK_FILTER_ON,
  setMinDateCompetitorPriceSource,
  togglePriceCPI,
  toggleQuickFilterOff,
} from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import { useCompetitorFiltersStore } from '../../../../../store/useCompetitorFiltersStore';
import { ICompetitorPriceSources } from '../../../Entities';
import { BaseQuickActionFilterProps, QuickActionFilter } from '../QuickActionFilter';

const { SelectInterval } = QuickActionFilter;

const MENU_STYLE = { width: '300px' };

const DEFAULT_MAX_CPI_DAYS = 7;

export const CpiDaysFilter = () => {
  const dispatch = useDispatch();
  const { competitorFilters } = useCompetitorFiltersStore();

  const minDateCompetitorPrice = useSelector((state: RootState) => {
    return state.gerenciadorPrecosReducer.quickActionsFilters.minDateCompetitorPrice;
  });

  const isCompetitorsPriceActive = useSelector((state: RootState) => {
    return state.gerenciadorPrecosReducer.quickActionsFilters.competitorPrices.isActive;
  });

  const [cpiDays, setCpiDays] = useState(minDateCompetitorPrice.value ?? DEFAULT_MAX_CPI_DAYS);

  const maxCpiDays = useSelector((state: RootState) => {
    return state.reducerIPA.basicConfig.competitorsDays?.competitor_days;
  });

  const handleToggleFilter = () => {
    if (!isCompetitorsPriceActive && !minDateCompetitorPrice.isActive) {
      dispatch(togglePriceCPI());
      return;
    }

    dispatch(setMinDateCompetitorPriceSource([]));
    dispatch(toggleQuickFilterOff({ name: 'competitorPrices' }));
    dispatch(toggleQuickFilterOff({ name: 'minDateCompetitorPrice' }));
  };

  const handleCloseFilter = () => {
    const daysCompetitorsPriceFilter = competitorFilters.find(filter => filter.filterType === 'daysCompetitorsPrice');

    const valueToUse = daysCompetitorsPriceFilter?.filterValue || cpiDays;

    dispatch(
      CHANGE_QUICK_FILTER_VALUE({
        name: 'minDateCompetitorPrice',
        value: valueToUse,
      }),
    );
    dispatch(TOGGLE_QUICK_FILTER_ON('minDateCompetitorPrice'));
  };

  const handleChangeCpiDays = (value: string | number) => {
    setCpiDays(Number(value));
  };

  const onChangeCpiSources = (sources: ICompetitorPriceSources[]) => {
    dispatch(setMinDateCompetitorPriceSource(sources));
  };

  const skin = useMemo(() => {
    let skin: BaseQuickActionFilterProps['skin'] = 'neutral';
    if (isCompetitorsPriceActive || minDateCompetitorPrice.isActive) {
      skin = 'primary';
    }
    return skin;
  }, [isCompetitorsPriceActive, minDateCompetitorPrice]);

  useEffect(() => {
    const daysCompetitorsPriceFilter = competitorFilters.find(filter => filter.filterType === 'daysCompetitorsPrice');

    if (daysCompetitorsPriceFilter?.filterValue || daysCompetitorsPriceFilter?.filterValue === 0) {
      setCpiDays(daysCompetitorsPriceFilter.filterValue);
    } else if (maxCpiDays) {
      setCpiDays(maxCpiDays);
    }
  }, [maxCpiDays, competitorFilters]);

  useEffect(() => {
    if (typeof minDateCompetitorPrice.value === 'number') {
      setCpiDays(minDateCompetitorPrice.value);
    }
  }, [minDateCompetitorPrice.value]);

  useEffect(() => {
    const competitorPricesFilter = competitorFilters.find(filter => filter.filterType === 'competitorPrices');

    const competitorPriceSourcesFilter = competitorFilters.find(filter => filter.filterType === 'competitorPriceSources');

    if (competitorPricesFilter?.filterValue === true) {
      dispatch(togglePriceCPI());
    }

    if (competitorPriceSourcesFilter?.filterValue) {
      dispatch(setMinDateCompetitorPriceSource(competitorPriceSourcesFilter.filterValue));
      dispatch(TOGGLE_QUICK_FILTER_ON('minDateCompetitorPrice'));
    }
  }, [competitorFilters, dispatch]);

  return (
    <SelectInterval
      inputValue={cpiDays.toString()}
      placeholder="Filtrar preços concorrentes"
      icon="MdStore"
      prefixLabel="Filtrar preço concorrente dos últimos"
      unitLabel="dias"
      maxValue={maxCpiDays}
      menuStyle={MENU_STYLE}
      skin={skin}
      onClick={handleToggleFilter}
      onChange={handleChangeCpiDays}
      onClose={handleCloseFilter}
      competitorPriceSources={{
        value: minDateCompetitorPrice.competitorPriceSources,
        onChange: onChangeCpiSources,
      }}
    />
  );
};
